import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getUsers as getUsersApi,
  addUser as addUserApi,
  editUser as editUserApi,
} from "../../apiCalls/caller";
import { toast } from "react-toastify";

export const getUsers = createAsyncThunk("users/getUsers", async (data) => {
  try {
    const response = getUsersApi(data);
    return response;
  } catch (error) {
    return error;
  }
});

export const addUser = createAsyncThunk("users/addUser", async (user) => {
  toast.dismiss();
  try {
    const response = addUserApi(user);
    const data = await response;
    toast.dismiss();
    if (data.success) {
      if (data.data === "User already exists") {
        toast.error("User already exists", {
          position: "top-center",
          autoClose: 3000,
        });
      } else
        toast.success("User created Successfully", {
          position: "top-center",
          autoClose: 3000,
        });
    } else {
      toast.error("User creation Failed " + data.message, {
        position: "top-center",
        autoClose: 3000,
      });
    }
    return response;
  } catch (error) {
    toast.error("User creation Failed " + error, {
      position: "top-center",
      autoClose: 3000,
    });
    return error;
  }
});

export const editUser = createAsyncThunk("users/editUser", async (user) => {
  toast.dismiss();
  try {
    const response = editUserApi(user);
    const data = await response;
    toast.dismiss();
    if (data.success) {
      toast.success("User updated Successfully", {
        position: "top-center",
        autoClose: 3000,
      });
    } else {
      toast.error("User updating Failed " + data.message, {
        position: "top-center",
        autoClose: 3000,
      });
    }
    return response;
  } catch (error) {
    toast.error("User updating Failed " + error, {
      position: "top-center",
      autoClose: 3000,
    });
    return error;
  }
});
